import { Component, OnInit, Input, Output, OnDestroy } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { EventEmitter } from '@angular/core';
import { Train } from '../../../trains/models/train';
import { FormValidationService } from '../../../../shared/services/form-validation.service';
import { Subscription } from 'rxjs';
import { DatePipe } from '@angular/common';
import { TranslateService } from "@ngx-translate/core";
@Component({
  selector: 'app-trains-selector-form',
  template: require('./trains-selector-form.component.html'),
  styles: [require('./trains-selector-form.component.sass')]
})
export class TrainsSelectorFormComponent implements OnInit, OnDestroy {

  @Input() trainTypes: string[];
  @Input() maintainers: string[];
  @Input() trains: Train[];
  @Input() isSingleTrainSelect: boolean;
  @Input() showHideSchedulingErrorsCheckbox: boolean;
  @Input() showAllTrainsCheckbox: boolean;
  @Input() submitButtonText: string;
  @Input() from: number; 
  @Input() to: number; 
  @Input() trainIds: string[];
  @Input() goodtrips: boolean;
  @Input() dateRangeDays: number;

  @Output() submitRequest = new EventEmitter<any>();
  @Output() trainsChange = new EventEmitter<Train[]>();

  dateFormat="dd/mm/yy"

  reportingForm: FormGroup;
  maxDateTime = new Date();

  private _today = new Date();

  private checkAllTrainsSubscription: Subscription | undefined;
  private listBoxTrainsSubscription: Subscription | undefined;

  constructor(
    private fb: FormBuilder, 
    public formValidatorService: FormValidationService,
    private datePipe: DatePipe,
    private translate: TranslateService
  ) {

    this.maxDateTime.setHours(23,59);
  
    this.reportingForm = this.fb.group({
      trainTypes: [[]],
      maintainers: [[]],
      trains: [[], [Validators.required]], 
      hideSchedulingErrors: [false],
      allTrains: [false],
      from: [new Date(this._today.setHours(0,0)), [Validators.required, this.dateValidator()]],
      to: [new Date(this._today.setHours(23,59)), [Validators.required, this.dateValidator()]]
    })

    this.checkAllTrainsSubscription = this.reportingForm.get("allTrains")?.valueChanges.subscribe(selectAll => {
      const trains = <Train[]>this.reportingForm.get('trains')?.value;
      if (selectAll && trains.length < this.trains.length) {
        this.reportingForm.get('trains')?.setValue([...this.trains]);
      } 
      if (!selectAll && (trains.length === this.trains.length))  {
        this.reportingForm.get('trains')?.setValue([]);
      }
    })

    this.listBoxTrainsSubscription = this.reportingForm.get("trains")?.valueChanges.subscribe((trains: Train[]) => {
      const allTrains = <Boolean>this.reportingForm.get('allTrains')?.value;
      if ((trains.length === this.trains.length) && !allTrains) {
        this.reportingForm.get('allTrains')?.setValue(true);
      } 

      if ((trains.length < this.trains.length) && allTrains) {
        this.reportingForm.get('allTrains')?.setValue(false);
      }
    })
  }

  ngOnInit(): void {
    const selectedTrains =  this.trainIds ? this.trains.filter(train => this.trainIds.find(id => parseInt(id) === train.id)) : [];
    this.reportingForm.patchValue({
      hideSchedulingErrors: this.goodtrips,
      trains: selectedTrains,
      from: this.from || new Date(this._today.setHours(0,0)),
      to: this.to || new Date(this._today.setHours(23,59))
    })
  }

  onSubmit = () => {
    if (this.reportingForm.valid) {
      const data = {
        trains: [...this.reportingForm.value.trains],
        from: this.datePipe.transform(this.reportingForm.value.from, 'yyyy-MM-dd-HH:mm'),
        to: this.datePipe.transform(this.reportingForm.value.to, 'yyyy-MM-dd-HH:mm'),
        hideSchedulingErrors: this.reportingForm.value.hideSchedulingErrors
      }; 
      this.submitRequest.emit({...data});
    } else {
      this.formValidatorService.validateAllFormFields(this.reportingForm);
    }
  }

  ngOnDestroy(): void {
    this.checkAllTrainsSubscription && this.checkAllTrainsSubscription.unsubscribe();
    this.listBoxTrainsSubscription && this.listBoxTrainsSubscription.unsubscribe();
  }

  trainsChanged = (trains: Train[]) => {
    this.trainsChange.emit(trains);
  }

  dateValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!this.dateRangeDays) {
        return null; //No period configured no validation to be done
      }

      const potentialMaxDateTime = new Date(this.reportingForm.controls.from.value.getTime() + (this.dateRangeDays * 86400000));
      if (this.reportingForm.controls.to.value > potentialMaxDateTime) {
        return {toDateOutOfRange: this.translate.instant('I18N_TRIP.PERIOD_RANGE_ERROR', {days: this.dateRangeDays})};
      } else {
        this.reportingForm.controls.from.setErrors(null);
        this.reportingForm.controls.to.setErrors(null);
        return null;
      }
    }
  }

}

